import React from "react";
import { useContent } from "@/context/ContentContext";
import { Loader } from "@/components/Loader";
import { ArchivedPage, DraftPage } from "@/pages/TripStatusPages";

// Server returns `restricted` when the journey is not active and the visitor is not an admin.
export const TripGate = ({ children }) => {
  const { content, loading } = useContent();
  if (loading || !content) return <Loader />;
  if (content.restricted) {
    return content.settings?.status === "draft" ? <DraftPage settings={content.settings} /> : <ArchivedPage />;
  }
  return children;
};
